import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ActivePackageCard.styles';
import { ActivePackageDetailsModal } from './ActivePackageDetailsModal';
import { AngleIcon } from '@/components/UI/Icons/Icons';
import { DateTimeFormat } from '@/constants/common';
import type { CurrentUserPackage } from '@/features/Profile/sections/Packages/api';
import { formatDate } from '@/utils/helpers';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';

type ActivePackageCardProps = {
  activePackage: CurrentUserPackage;
  onRenew?: (activePackage: CurrentUserPackage) => void;
};

export function ActivePackageCard({
  activePackage,
  onRenew,
}: ActivePackageCardProps) {
  const { t } = useTranslation();
  const [isDetailsOpen, , openDetails, closeDetails] =
    useToggleOpenState(false);

  function handleRenew() {
    closeDetails();
    onRenew?.(activePackage);
  }

  return (
    <>
      <S.Card $packageName={activePackage.name}>
        <S.Header>
          <S.Title>{activePackage.name}</S.Title>
          <S.DetailsButton
            onClick={openDetails}
            aria-label={t('pages.cabinet.package_information')}
          >
            <AngleIcon />
          </S.DetailsButton>
        </S.Header>
        <S.PackageDetails>
          <S.Label>{t('pages.cabinet.expiration_date')}</S.Label>
          <S.Date>
            {formatDate(activePackage.expiresAt, DateTimeFormat.date)}
          </S.Date>
        </S.PackageDetails>
        {onRenew && (
          <S.RenewButton isFullWidth borderRadius={14} onClick={handleRenew}>
            {t('pages.cabinet.renew_package')}
          </S.RenewButton>
        )}
      </S.Card>
      <ActivePackageDetailsModal
        activePackage={activePackage}
        isOpen={isDetailsOpen}
        onClose={closeDetails}
        onRenew={onRenew ? handleRenew : undefined}
      />
    </>
  );
}
